import * as actions from "./actionTypes/index";

export const StandartGamesListUpdateReceived = (payload, key) => {
    return {
        type: actions.STANDART_GAMES_LIST_UPDATE_RECEIVED,
        key,
        payload
    };
};

export const ResetStandartGamesList = (key) => {
    return {
        type: actions.RESET_STANDART_GAMES_LIST,
        key
    };
};